export default class OrderInfoWindow {
  id: string | null;
  infoWindow: any;

  public receivedUpdateEvent = ({ data: latestData, map }) => {
    this.tearDown();

    const point = latestData.geojson.features.find(
      ({ properties: properties }) =>
        properties?.type === "Order" && properties?.infoWindowState === "show",
    );

    if (!point) {
      return;
    }

    const infoWindow = this.create({ map, point });

    infoWindow.open(map);

    this.id = point.properties.id;
    this.infoWindow = infoWindow;
  };

  public receivedRemoveFeaturesEvent = ({ feature }) => {
    const id = feature.getProperty("id");
    const type = feature.getProperty("type");

    if (type !== "Order") {
      return;
    }
    if (this.id !== id) {
      return;
    }

    this.tearDown();
    this.id === null;
  };

  private create = ({ map, point }) => {
    const pointFeature = map.data.getFeatureById(point.properties.id);
    const content = this.getContent({ pointFeature });
    const position = this.getPosition({ pointFeature });
    const infoWindow = new window.google.maps.InfoWindow({
      content,
      position,
      // This is the offset of the infoWindow from the pin. -50 is just a magical number in pixels
      // that seems to work nicely.
      pixelOffset: { width: 0, height: -50 },
    });

    return infoWindow;
  };

  private tearDown = () => {
    this.infoWindow?.close();
    this.infoWindow = null;
  };

  private getContent = ({ pointFeature }) => {
    const template = document.createElement("template");
    template.innerHTML = pointFeature.getProperty("infoWindowTemplate");
    return template.content;
  };

  private getPosition = ({ pointFeature }) => {
    const position = {
      lat: pointFeature.getGeometry().get().lat(),
      lng: pointFeature.getGeometry().get().lng(),
    };

    return position;
  };
}

declare global {
  interface Window {
    google: any;
  }
}
